import React, {useEffect, useRef} from 'react';

import Textarea from './Textarea';

const DynamicHeightTextarea = ({value, maxHeight = 190, ...rest}) => {
    const ref = useRef();

    useEffect(() => {
        const textarea = ref.current;
        const adjustHeight = () => {
            textarea.style.overflow = 'hidden';
            textarea.style.height = '0px';

            const scrollHeight = textarea.scrollHeight;
            const newHeight = Math.min(scrollHeight, maxHeight);

            textarea.style.height = `${newHeight}px`;
            textarea.style.overflowY = scrollHeight > maxHeight ? 'scroll' : 'hidden';
        };

        adjustHeight();
    }, [value, maxHeight]);

    return <Textarea ref={ref} value={value} {...rest} />;
};

export default DynamicHeightTextarea;
